import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {NeedToLogoutResponse} from "../interface/needToLogoutResponse";
import {VersionResponse} from "../interface/versionResponse";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  checkNeedToLogout(): Observable<NeedToLogoutResponse> {
    return this.http.get<NeedToLogoutResponse>(`${this.apiUrl}/config/need-to-logout`);
  }

  getBackAndFrontVersion() {
    return this.http.get<VersionResponse>(`${this.apiUrl}/config/version`);
  }
}
